const ORDERS = [
  'orders',
  'orders/:id',
  'orders-export',
  'order-export/new',
  'order-export/report/:id',
  'orders-import',
  'orders-import/new',
  'shippings',
];

export default ORDERS;
